// src/api/mock/contactData.js

export const contactMockData = {
  phone: "081362443808",
  email: "andrisibarani91@gmail.com",
  location: "Jakarta, Indonesia",
  social: {
    github: "https://github.com/andrisibarani",
    linkedin: "https://www.linkedin.com/in/andrisibarani/",
    instagram: "https://www.instagram.com/andri_sibarani",
  },
};